import { useEffect } from 'react';
export const useEscapeKey = (callback) => {
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') {
                callback();
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [callback]);
};
//# sourceMappingURL=use-esc-key-listener.js.map